import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const posts = [
  {
    slug: 'compound-movements-over-35',
    category: 'Training',
    title: '5 Compound Movements Everyone Over 35 Must Master',
    excerpt:
      'These foundational exercises build real-world strength, protect your joints, and keep you moving like you\'re in your twenties.',
    image:
      'https://public.readdy.ai/ai/img_res/8dd8e339d630598c59db38b1f8bd28ab.jpg',
    date: 'March 15, 2024',
    readTime: '8 min read',
  },
  {
    slug: 'nutrition-mistakes-after-35',
    category: 'Nutrition',
    title: 'The 3 Nutrition Mistakes Killing Your Progress After 35',
    excerpt:
      'Stop spinning your wheels. These common nutrition errors are sabotaging your results and making fat loss nearly impossible.',
    image:
      'https://readdy.ai/api/search-image?query=woman%20preparing%20healthy%20meal%20prep%20containers%20balanced%20nutrition%20protein%20vegetables%20whole%20foods%20clean%20eating%20fitness%20diet%20organized%20meal%20planning%20kitchen%20modern%20professional%20food%20photography%20natural%20lighting&width=800&height=500&seq=nutrition1female&orientation=landscape',
    date: 'March 10, 2024',
    readTime: '6 min read',
  },
  {
    slug: 'mindset-shift-for-lasting-change',
    category: 'Mindset',
    title: 'The Mindset Shift That Changes Everything',
    excerpt:
      "Motivation fades. Discipline is unreliable. Here's the one mental shift that separates those who transform from those who quit.",
    image:
      'https://readdy.ai/api/search-image?query=determined%20athletic%20person%20focused%20mindset%20mental%20strength%20gym%20training%20motivation%20discipline%20powerful%20warrior%20mentality%20dark%20dramatic%20lighting%20inspirational%20diverse%20fitness&width=800&height=500&seq=mindset1inclusive&orientation=landscape',
    date: 'March 5, 2024',
    readTime: '7 min read',
  },
  {
    slug: 'sleep-recovery-muscle-growth',
    category: 'Recovery',
    title: 'Why Sleep Is Your Secret Weapon for Muscle Growth After 35',
    excerpt:
      'You can train hard and eat clean, but without quality sleep, you\'re leaving gains on the table. Here\'s how to optimize your recovery.',
    image:
      'https://readdy.ai/api/search-image?query=peaceful%20bedroom%20environment%20quality%20sleep%20recovery%20rest%20dark%20room%20comfortable%20bed%20wellness%20relaxation%20nighttime%20routine%20health%20optimization%20minimal%20modern%20design%20calming%20atmosphere&width=800&height=500&seq=sleep1&orientation=landscape',
    date: 'March 1, 2024',
    readTime: '7 min read',
  },
  {
    slug: 'testosterone-optimization-naturally',
    category: 'Health',
    title: 'How to Naturally Optimize Hormones After 35',
    excerpt:
      'Low energy, stubborn fat, and declining strength aren\'t inevitable. These science-backed strategies help you optimize hormones naturally.',
    image:
      'https://readdy.ai/api/search-image?query=strong%20confident%20athletic%20woman%20powerful%20physique%20natural%20strength%20training%20health%20vitality%20energy%20fitness%20lifestyle%20gym%20weights%20determination%20wellness%20hormonal%20balance&width=800&height=500&seq=hormones1female&orientation=landscape',
    date: 'February 25, 2024',
    readTime: '9 min read',
  },
  {
    slug: 'intermittent-fasting-guide',
    category: 'Nutrition',
    title: 'Intermittent Fasting for People Over 35: What Actually Works',
    excerpt:
      'Intermittent fasting can accelerate fat loss and improve energy, but only if you do it right. Here\'s your complete guide.',
    image:
      'https://readdy.ai/api/search-image?query=clock%20timer%20meal%20timing%20intermittent%20fasting%20schedule%20healthy%20eating%20window%20nutrition%20timing%20concept%20clean%20minimal%20design%20food%20planning%20wellness%20lifestyle&width=800&height=500&seq=fasting1&orientation=landscape',
    date: 'February 20, 2024',
    readTime: '8 min read',
  },
  {
    slug: 'cardio-vs-weights-fat-loss',
    category: 'Training',
    title: 'Cardio vs Weights: The Truth About Fat Loss After 35',
    excerpt:
      'The cardio vs weights debate ends here. Discover which training method actually burns more fat and builds a better physique.',
    image:
      'https://readdy.ai/api/search-image?query=athletic%20man%20training%20gym%20cardio%20running%20treadmill%20versus%20weight%20lifting%20dumbbells%20comparison%20fitness%20workout%20strength%20training%20fat%20loss%20exercise%20split%20screen%20concept&width=800&height=500&seq=cardioweights1&orientation=landscape',
    date: 'February 15, 2024',
    readTime: '7 min read',
  },
  {
    slug: 'home-gym-essentials',
    category: 'Training',
    title: 'Building a Home Gym That Actually Gets Results',
    excerpt:
      'You don\'t need a fancy gym membership. Here\'s how to build a minimalist home gym that delivers maximum results.',
    image:
      'https://readdy.ai/api/search-image?query=woman%20training%20home%20gym%20setup%20essential%20equipment%20dumbbells%20kettlebells%20yoga%20mat%20clean%20organized%20space%20functional%20fitness%20training%20area%20simple%20effective%20workout%20space%20natural%20light&width=800&height=500&seq=homegym1female&orientation=landscape',
    date: 'February 10, 2024',
    readTime: '6 min read',
  },
  {
    slug: 'stress-cortisol-fat-loss',
    category: 'Health',
    title: 'How Stress Is Sabotaging Your Fat Loss (And What to Do)',
    excerpt:
      'High cortisol from chronic stress makes fat loss nearly impossible. Learn how to manage stress and optimize your hormones.',
    image:
      'https://readdy.ai/api/search-image?query=calm%20relaxed%20woman%20meditation%20stress%20relief%20peaceful%20environment%20wellness%20mental%20health%20cortisol%20management%20breathing%20exercise%20mindfulness%20tranquil%20setting%20natural%20light%20serene&width=800&height=500&seq=stress1female&orientation=landscape',
    date: 'February 5, 2024',
    readTime: '8 min read',
  },
  {
    slug: 'protein-intake-complete-guide',
    category: 'Nutrition',
    title: 'The Complete Protein Guide for People Over 35',
    excerpt:
      'How much protein do you really need? What are the best sources? This guide answers all your protein questions once and for all.',
    image:
      'https://readdy.ai/api/search-image?query=high%20protein%20foods%20chicken%20breast%20eggs%20fish%20meat%20lean%20protein%20sources%20healthy%20nutrition%20meal%20prep%20fitness%20diet%20muscle%20building%20clean%20eating%20variety&width=800&height=500&seq=protein1&orientation=landscape',
    date: 'January 30, 2024',
    readTime: '9 min read',
  },
  {
    slug: 'consistency-habits-transformation',
    category: 'Mindset',
    title: 'The Power of Consistency: Small Habits, Big Transformations',
    excerpt:
      'Forget motivation and willpower. Building the right habits is the only way to create lasting change. Here\'s how to do it.',
    image:
      'https://readdy.ai/api/search-image?query=daily%20routine%20habit%20tracking%20consistency%20progress%20journal%20fitness%20lifestyle%20discipline%20commitment%20small%20steps%20transformation%20journey%20motivation%20planner%20organized%20systematic%20approach&width=800&height=500&seq=habits1&orientation=landscape',
    date: 'January 25, 2024',
    readTime: '7 min read',
  },
];

export default function BlogGrid() {
  const { elementRef } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section className="py-20" style={{ background: '#ffffff' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={elementRef}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 scroll-animate-fade-up"
        >
          {posts.map((post, index) => (
            <Link key={index} to={`/blog/${post.slug}`} className="group cursor-pointer">
              <article
                className="h-full flex flex-col rounded-xl overflow-hidden transition-all duration-300"
                style={{ background: '#ffffff', border: '1px solid #e5e5e5' }}
              >
                <div className="relative w-full h-56 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute top-4 left-4">
                    <span
                      className="inline-block px-3 py-1 text-xs font-bold tracking-wider uppercase rounded-full"
                      style={{ background: 'rgba(184,134,11,0.9)', color: '#ffffff' }}
                    >
                      {post.category}
                    </span>
                  </div>
                </div>
                <div className="flex-1 p-6 flex flex-col">
                  <h3
                    className="text-xl font-bold mb-3 leading-tight transition-colors duration-300 group-hover:opacity-80"
                    style={{ color: '#0f0f0f' }}
                  >
                    {post.title}
                  </h3>
                  <p className="text-sm leading-relaxed mb-4 flex-1" style={{ color: '#666666' }}>
                    {post.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs" style={{ color: '#999999' }}>
                    <span>{post.date}</span>
                    <span>{post.readTime}</span>
                  </div>
                  <div
                    className="mt-4 flex items-center gap-2 font-semibold text-sm transition-all duration-300"
                    style={{ color: '#B8860B' }}
                  >
                    <span>Read More</span>
                    <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}